import { Injectable } from '@angular/core';
import { openDB } from 'idb';
import { BehaviorSubject, delay } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DatabaseService {
  public $database = new BehaviorSubject<any>(null);

  constructor() {
    if (!this.$database.getValue()) {
      openDB('ibextouch', 1, {
        upgrade(db) {
          if (!db.objectStoreNames.contains('store')) {
            db.createObjectStore('store');
          }
        },
      }).then(db => {
        this.$database.next(db);
      });
    }
  }

  public get(key): Promise<any> {
    return new Promise(resolve => {
      const dbSub = this.$database.pipe(delay(0)).subscribe(db => {
        if (db) {
          if (dbSub) {
            dbSub.unsubscribe();
          }
          db.get('store', key).then(result => {
            resolve(result)
          });
        }
      });
    });
  }

  public put(key, value): Promise<any> {
    return new Promise(resolve => {
      const dbSub = this.$database.pipe(delay(0)).subscribe(db => {
        if (db) {
          if (dbSub) {
            dbSub.unsubscribe();
          }
          db.put('store', value, key).then(result => {
            resolve(result)
          });
        }
      });
    });
  }
}
